import React, { JSX } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import OrderBook from './pages/OrderBook';
import NewOffer from './pages/NewOffer';
import MyOffers from './pages/MyOffers';
import Matches from './pages/Matches';
import Profile from './pages/Profile';
import Wishlist from './pages/Wishlist';
import Admin from './pages/Admin';
import VerifyAddress from './pages/VerifyAddress';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Home from './pages/Home';
import HomeDe from './pages/HomeDe';
import HomeSk from './pages/HomeSk';
import HomeCz from './pages/HomeCz';
import HomePl from './pages/HomePl';
import HomeHu from './pages/HomeHu';

const token = () => localStorage.getItem('token');

const PrivateRoute = ({ children }: { children: JSX.Element }) => {
  return token() ? children : <Navigate to="/login" />;
};

const getHome = () => {
  const host = window.location.hostname.toLowerCase();
  if (host === 'bullionx.de' || host === 'bullionx.at') return <HomeDe />;
  if (host === 'bullionx.sk') return <HomeSk />;
  if (host === 'bullionx.cz') return <HomeCz />;
  if (host === 'bullionx.pl') return <HomePl />;
  if (host === 'bullionx.hu') return <HomeHu />;
  return <Home />;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={getHome()} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/verify-address" element={<VerifyAddress />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/home" element={<PrivateRoute><Layout><Dashboard /></Layout></PrivateRoute>} />
        <Route path="/orderbook" element={<PrivateRoute><Layout><OrderBook /></Layout></PrivateRoute>} />
        <Route path="/new-offer" element={<PrivateRoute><Layout><NewOffer /></Layout></PrivateRoute>} />
        <Route path="/my-offers" element={<PrivateRoute><Layout><MyOffers /></Layout></PrivateRoute>} />
        <Route path="/matches" element={<PrivateRoute><Layout><Matches /></Layout></PrivateRoute>} />
        <Route path="/profile" element={<PrivateRoute><Layout><Profile /></Layout></PrivateRoute>} />
        <Route path="/wishlist" element={<PrivateRoute><Layout><Wishlist /></Layout></PrivateRoute>} />
        <Route path="/admin" element={<PrivateRoute><Layout><Admin /></Layout></PrivateRoute>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
